import React from 'react';

import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import PropTypes from 'prop-types';

const JobSearchItem = (props) => {
    const { item } = props;

    return (
        <tr>
            <td>
                {item.customerName}
            </td>
            <td className="d-none d-md-table-cell">
                {item.jobNumber}
            </td>
            <td className="d-none d-md-table-cell">
                {item.designerName}
            </td>
            <td>
                {formatter.date(item.installationDate)}
            </td>
            <td>
                {formatter.currency(item.total)}
            </td>
            <td className="d-none d-sm-table-cell">
                {item.leadSourceName}
            </td>
            <td className="d-none d-lg-table-cell">
                {item.subLeadSourceName}
            </td>
            <td className="button-cell">
                <EditDeleteButton
                    canDelete={false}
                    editItem={props.editItem}
                    viewItem={props.editItem}
                    showDelete={false}
                    showText={false}
                    acl={item.acl}
                />
            </td>
        </tr>
    );
}

JobSearchItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default JobSearchItem;